import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import Label from '../../base/label/components/web/Label';
import Tooltip from '../../base/tooltip/components/Tooltip';
import { toggleLanguageSelectorDialog } from '../../subtitles/actions.web';
const TranscribingLabel = () => {
    // @ts-ignore
    const { iAmRecorder, isXbees } = useSelector((state) => state['features/base/config']);
    const _showLabel = useSelector((state) => state['features/transcribing'].isTranscribing);
    // @ts-ignore Wildix changes
    const { transcriptionLanguageCopied, transcriptionCode } = useSelector((state) => state['wildix/features/transcribing']);
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const onClick = isXbees ? () => dispatch(toggleLanguageSelectorDialog()) : undefined;
    if (!_showLabel || iAmRecorder || !transcriptionCode) {
        return null;
    }
    return (React.createElement(Tooltip, { content: t('transcribing.labelToolTipWithLang', { lang: t(transcriptionLanguageCopied) }), position: 'bottom' },
        React.createElement(Label, { className: 'recording-label', text: t('transcriptionsWildix.labelLang', { lang: transcriptionCode }), onClick: onClick })));
};
export default TranscribingLabel;
